/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Failed_LoadInputs */

const en_plan_failed_load = /** @type {(inputs: Plan_Failed_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load subscription`)
};

const es_plan_failed_load = /** @type {(inputs: Plan_Failed_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar la suscripción`)
};

/**
* | output |
* | --- |
* | "Failed to load subscription" |
*
* @param {Plan_Failed_LoadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_failed_load = /** @type {((inputs?: Plan_Failed_LoadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Failed_LoadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_failed_load(inputs)
	return en_plan_failed_load(inputs)
});